import React from 'react';

import './style.scss';

export default ({ className='',  children, ...props }) => <div className={`zt-event-buy__tooltip ${className}`} {...props}>{children}</div>